<template>
  <LoginWrapper>
    <!-- form -->

    <div class="login-content">
      <div class="login-logo">
        <Icon type="logo" />
      </div>
      <a-form :form="form" class="login-form">
        <!-- 用户名 -->
        <div class="login-form-item">
          <a-form-item>
            <a-input
              :placeholder="$t('login_form_username_placeholder')"
              v-decorator="[
                'userName',
                {
                  rules: [
                    {
                      required: true,
                      message: this.$t('login_form_username_required_msg'),
                    },
                  ],
                },
              ]"
              @input="input"
              ref="userName"
            >
              <Icon type="user" slot="prefix" />
            </a-input>
          </a-form-item>
        </div>

        <!-- 密码 -->
        <div class="login-form-item">
          <a-form-item>
            <a-input-password
              :placeholder="$t('login_form_password_placeholder')"
              v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: this.$t('login_form_password_required_msg'),
                    },
                  ],
                },
              ]"
              @input="input"
              autocomplete="off"
            >
              <Icon type="lock" slot="prefix" />
            </a-input-password>
          </a-form-item>
        </div>

        <!-- 验证码 -->
        <div class="captcha login-form-item">
          <div class="captcha-left">
            <a-form-item>
              <a-input
                :placeholder="$t('login_form_captcha_placeholder')"
                class="captcha-input"
                v-decorator="[
                  'captcha',
                  {
                    rules: [
                      {
                        required: true,
                        message: this.$t('login_form_captcha_required_msg'),
                      },
                    ],
                  },
                ]"
                @input="input"
                ref="captcha"
              >
                <Icon type="verified" slot="prefix" />
              </a-input>
            </a-form-item>
          </div>
          <div class="captcha-right">
            <div class="captcha-img" @click="changeCaptcha">
              <img :src="`/api/unauth/code?_t=${captchaTime}`" />
            </div>
          </div>
        </div>

        <a-button type="primary" @click="login" :loading="submitting" ref="loginBtn">
          {{ $t('login_btn') }}
        </a-button>
      </a-form>

      <div class="login-error">
        <div class="login-error-content" v-show="error && !submitting">
          {{ error }}
        </div>
      </div>

      <!-- 找回密码 -->
      <div class="forgot-password">
        <router-link to="/find-password">
          {{ $t('login_forgot_link_text') }}
        </router-link>
      </div>
    </div>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/Layout/Login.vue';
import { setToken } from '@/libs/cookie';
import { LoginSubmit } from '@/api/login';
import { mapGetters } from 'vuex';
import { trim } from '@/libs/utils';

export default {
  components: {
    LoginWrapper,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'loginForm' }),
      // 提交状态
      submitting: false,
      // 登录错误
      error: '',
      captchaTime: new Date().getTime(),

      // 隐私协议
      visible: false,
      confirmLoading: false,
      ModalText: '',
    };
  },

  mounted() {
    if (!this.userInfo) {
      // 绑定enter事件
      this.enterKeyup();
      this.focusUserNameInput();
    }
  },

  beforeDestroy() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },

  computed: {
    ...mapGetters(['authList', 'isSuperAdmin', 'userInfo']),
  },

  methods: {
    changeCaptcha() {
      this.captchaTime = new Date().getTime();
    },

    // 输入事件
    input() {
      this.error = '';
    },

    focusUserNameInput() {
      this.$refs.userName.focus();
    },

    // 表单重置项
    resetForm() {
      this.changeCaptcha();
      this.submitting = false;
      // 清空验证码
      this.form.setFields({ captcha: '' });
    },

    // 登录提交
    login() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            password: values.password,
            userName: trim(values.userName),
            validCode: trim(values.captcha),
            lang: this.currentLanguage,
          };

          this.submitting = true;
          LoginSubmit(params)
            .then(res => {
              if (res.code === 0 && res.data) {
                // 存储token
                this.$store.commit('setToken', res.data);

                // 设置cookie
                setToken(res.data);

                // 登录成功，重新刷新一下页面，在App.vue里会重新获取userInfo的信息
                window.location.href = '/';

                return;
              }
              this.resetForm();
              this.error = res.message || this.$t('com_error_net');
              if (res.code === 20015) {
                this.$refs.captcha.focus();
              } else {
                this.focusUserNameInput();
              }
            })
            .catch(err => {
              console.log('err', err);
              this.resetForm();
              this.error = this.$t('com_error_net');
            });
        } else {
          this.focusUserNameInput();
        }
      });
    },

    enterKey(event) {
      const componentName = this.$route.name;
      if (componentName == 'Login') {
        const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
        if (code == 13) {
          this.login();
        }
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener('keyup', this.enterKey);
    },
    enterKeyup() {
      document.addEventListener('keyup', this.enterKey);
    },
  },
};
</script>

<style lang="less" scoped>
.login-content {
  width: 360px;
  margin: 0 80px 80px 80px;

  .login-logo {
    text-align: center;
    padding: 58px 0 5px 0;
    svg {
      margin-bottom: 20px;
      width: 275.2px;
      height: 121.6px;
    }
  }

  .login-title {
    font-size: 20px;
    color: #333;
  }

  .login-language {
    width: 120px;
    ::v-deep .ant-select-selection {
      border: none;
      box-shadow: 0 0 10px rgba(118, 118, 118, 0.2);
    }
  }

  // 验证码
  .captcha {
    display: flex;
    border-radius: 8px;

    .captcha-left {
      flex: 1;
    }

    .captcha-right {
      width: 120px;
      display: flex;
      justify-content: right;
      .captcha-img {
        width: 110px;
        background: #eee;
        height: 40px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid rgba(0, 0, 0, 0.15);

        img {
          width: auto;
          height: 100%;
          max-width: 100%;
          max-height: 40px;
          cursor: pointer;
        }
      }
    }
  }

  .login-error {
    margin: 15px 0 10px 0;
    line-height: 20px;
    color: #f5222d;
    font-size: 12px;
    .login-error-content {
      border-radius: 5px;
      padding: 5px 0;
      margin-bottom: 15px;
      text-align: center;
    }
  }

  ::v-deep .login-form {
    .login-form-item {
      height: 70px;
    }

    .ant-input,
    .ant-select-selection__rendered,
    .ant-select-selection {
      height: 40px;
      line-height: 40px;
    }

    .ant-btn-primary {
      font-size: 18px;
      height: 50px;
      width: 100%;
      border-radius: 8px;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
    }
  }

  .forgot-password {
    display: flex;
    justify-content: right;

    .icon {
      width: 26px;
      height: 23px;
      position: relative;
      top: 8px;
      color: #888;
    }

    a {
      font-size: 14px;
    }
  }
}

.login-copyright {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
</style>
